import router from '@/app/router';
import store from '@/app/store';

function isUnixTs(value) {
  return typeof value === 'number' && value.toString().length === 10;
}

/**
 * Time to date filter
 * @example {{ Date.now() | date }}
 * @example {{ new Date() | date('short') }}
 * @example {{ 1528526822 | date('long') }}
 * @example {{ '2016-02-23T18:25:43Z' | date('full') }}
 * @param {string | number} value - timestamp or Date string value
 * @param {string} arg - 'short' | 'long' | 'full'
 */
export default function (value, arg) {
  if (!value) {
    return '';
  }

  let date;
  const time = isUnixTs(value) ? value * 1000 : value;

  try {
    date = time instanceof Date ? time : new Date(time);
    return router.app.$d(date, arg || 'long', store.state.locale);
  } catch (e) {
    console.warn(`Error: Wrong date filter value: ${value}`);
    return '';
  }
}
